<template>
    <div class="term-modal">
        <!-- confirm modal -->
        <b-modal
            :id="modalConfirm.id"
            modal-class="consent-modal"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <top-bar class="topbar"></top-bar>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="head1">
                        ลงทะเบียนกับชาเนล เพื่อรับข่าวสารจากแบรนด์
                    </div>
                    <div>
                        ข้อมูลอีเว้นท์ ผลิตภัณฑ์ขนาดทดลอง และบริการต่างๆ
                    </div>
                </div>

                <div class="modal-base-body">
                    <div class="term-wrapper">
                        <div class="detail-term">
                            <div>
                                <p class="text-head-term">
                                    คำชี้แจงการเก็บรักษาข้อมูลส่วนบุคคล
                                </p>
                            </div>
                            <div>
                                ท่านยินยอมด้วยตัวท่านเองและในนามของบุคคลอื่นใดผู้ซึ่งมีข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้แก่ชาเนลและบริษัทแม่และบริษัทในเครือ
                                (“ชาเนล”) โดยใช้ข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้
                                (“ข้อมูลส่วนตัว”)
                                เพื่อวัตถุประสงค์ในการควบคุมการขายและการเก็บบันทึก
                                เพื่อนำประสบการณ์ของท่านมาใช้กับชาแนล
                                บนพื้นฐานของคุณสมบัติส่วนบุคคลของท่าน
                                วันสำคัญของท่านและข้อมูลส่วนบุคคลอื่น ๆ
                                บริหารการส่งมอบและส่งคืนผลิตภัณฑ์
                                ให้บริการลูกค้าและการตอบข้อซักถามและข้อร้องเรียนของท่าน
                                เพื่อวัตถุประสงค์ในการวิจัยและพัฒนาผลิตภัณฑ์
                                เพื่อวัตถุประสงค์ทางการตลาดทางตรงตามความยินยอมของท่าน
                                ซึ่งเกี่ยวข้องกับแฟชั่นของและอุปกรณ์เสริม
                                นาฬิกาและเครื่องเพชรพลอยคุณภาพดี
                                และผลิตภัณฑ์น้ำหอมและความงามของชาแนล
                                ตามที่ท่านยินยอม
                                ท่านตกลงว่าข้อมูลส่วนบุคคลอาจแบ่งปัน เปิดเผย
                                หรือถ่ายทอดไปสู่กลุ่มบริษัทชาเนลทั่วโลก
                                และไปสู่ตัวแทนและผู้ให้บริการทางการบริหาร
                                การตลาด และการวิจัยเพื่อวัตถุประสงค์ดังกล่าว
                                ชาเนลจะปฏิบัติตามคำร้องขอของท่านที่จะไม่ใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาดที่กล่าวไว้ข้างต้น
                                หากท่านประสงค์ที่จะร้องขอดังกล่าว
                                กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า
                                ท่านยินยอมที่จะถ่ายโอนข้อมูลส่วนบุคคลไปยังสถานที่นอกประเทศไทย
                                เพื่อดำเนินการตามวัตถุประสงค์
                                หรือวัตถุประสงค์ที่เกี่ยวข้องโดยตรง
                                ตามที่กำหนดไว้ในคำชี้แจงนี้
                                ท่านมีสิทธิร้องขอให้เข้าถึง แก้ไข
                                หรือลบข้อมูลส่วนบุคคล
                                หากท่านประสงค์ให้ชื่อของท่านถูกลบออกจากรายชื่อผู้ติดต่อและรายชื่อผู้รับไปรษณีย์ของเรา
                                หรือประสงค์สอบถามข้อมูลส่วนบุคคล
                                (รวมถึงการเข้าถึงและการแก้ไข)
                                กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า, Chanel
                                Customer Care, 8th floor, The Offices at Central
                                World Building, No. 999/9, Rama I Road,
                                Pathumwan District, Bangkok 10330, Thailand.
                                (ที่อยู่ทางอีเมล client.careth@chanel.com)
                            </div>
                        </div>
                        <div class="blur-text"></div>
                    </div>
                </div>
                <div class="modal-base-footer">

                    <div class="check-term-wrapper">
                        <div class="check" @click="clickCheckRadio()">
                            <img v-if="modalConfirm.isChecked" src="../../assets/img/radio_active.png" />
                            <img v-if="!modalConfirm.isChecked" src="../../assets/img/radio_unactive.png" />
                        </div>
                        <div class="text">
                            ข้าพเจ้าประสงค์รับการสื่อสารการตลาดทางตรงตามที่กำหนดไว้ในคำชี้แจงด้านการเก็บข้อมูลส่วนบุคคลข้างต้นผ่านทางอีเมล
                            โทรศัพท์ สื่อสังคมออนไลน์ ข้อความสั้น
                            ข้อความโต้ตอบแบบทันที ไปรษณีย์
                            และวิธีอื่นใดที่ข้าพเจ้าอาจให้ความยินยอมเป็นครั้งคราว
                        </div>
                    </div>
                    <div class="btn-accept-term">
                        <button
                            class="btn btn-primary btn-custom-dark"
                            @click="
                                modalConfirm.isChecked ? clickOkModalConfirm() : clickCancelModalConfirm() " >
                            {{ modalConfirm.strBtnOk }}
                        </button>
                    </div>
                </div>
                <!-- <div class="modal-base">
                <div class="modal-base-head">

                    <p class="text-head-no-underline">ลงทะเบียนกับชาเนล เพื่อรับข่าวสารจากแบรนด์</p>
                    <p class="text-head2">
                        ข้อมูลอีเว้นท์ ผลิตภัณฑ์ขนาดทดลอง และบริการต่างๆ
                    </p>
                </div>
                <div class="blur-text"> </div>
                <div class="modal-base-body-wrapper">
                <div class="modal-base-body">

                    <p class="text-head-term">คำชี้แจงการเก็บรักษาข้อมูลส่วนบุคคล</p>
                    <p class="text-sub-head">
                        ท่านยินยอมด้วยตัวท่านเองและในนามของบุคคลอื่นใดผู้ซึ่งมีข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้แก่ชาเนลและบริษัทแม่และบริษัทในเครือ (“ชาเนล”) โดยใช้ข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้ (“ข้อมูลส่วนตัว”) เพื่อวัตถุประสงค์ในการควบคุมการขายและการเก็บบันทึก เพื่อนำประสบการณ์ของท่านมาใช้กับชาแนล บนพื้นฐานของคุณสมบัติส่วนบุคคลของท่าน วันสำคัญของท่านและข้อมูลส่วนบุคคลอื่น ๆ บริหารการส่งมอบและส่งคืนผลิตภัณฑ์ ให้บริการลูกค้าและการตอบข้อซักถามและข้อร้องเรียนของท่าน เพื่อวัตถุประสงค์ในการวิจัยและพัฒนาผลิตภัณฑ์ เพื่อวัตถุประสงค์ทางการตลาดทางตรงตามความยินยอมของท่าน ซึ่งเกี่ยวข้องกับแฟชั่นของและอุปกรณ์เสริม นาฬิกาและเครื่องเพชรพลอยคุณภาพดี และผลิตภัณฑ์น้ำหอมและความงามของชาแนล ตามที่ท่านยินยอม ท่านตกลงว่าข้อมูลส่วนบุคคลอาจแบ่งปัน เปิดเผย หรือถ่ายทอดไปสู่กลุ่มบริษัทชาเนลทั่วโลก และไปสู่ตัวแทนและผู้ให้บริการทางการบริหาร การตลาด และการวิจัยเพื่อวัตถุประสงค์ดังกล่าว ชาเนลจะปฏิบัติตามคำร้องขอของท่านที่จะไม่ใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาดที่กล่าวไว้ข้างต้น หากท่านประสงค์ที่จะร้องขอดังกล่าว กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า ท่านยินยอมที่จะถ่ายโอนข้อมูลส่วนบุคคลไปยังสถานที่นอกประเทศไทย เพื่อดำเนินการตามวัตถุประสงค์ หรือวัตถุประสงค์ที่เกี่ยวข้องโดยตรง ตามที่กำหนดไว้ในคำชี้แจงนี้ ท่านมีสิทธิร้องขอให้เข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคล หากท่านประสงค์ให้ชื่อของท่านถูกลบออกจากรายชื่อผู้ติดต่อและรายชื่อผู้รับไปรษณีย์ของเรา หรือประสงค์สอบถามข้อมูลส่วนบุคคล (รวมถึงการเข้าถึงและการแก้ไข) กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า, Chanel Customer Care, 8th floor, The Offices at Central World Building, No. 999/9, Rama I Road, Pathumwan District, Bangkok 10330, Thailand. (ที่อยู่ทางอีเมล contact-th@chanel.com)
                    </p>

                </div>
                </div>
                <div class="text-term-accept">
                    <div class="pb-3">
                        <label class="text">
                            <div>ข้าพเจ้าประสงค์รับการสื่อสารการตลาดทางตรงตามที่กำหนดไว้ในคำชี้แจงด้านการเก็บข้อมูลส่วนบุคคลข้างต้นผ่านทางอีเมล โทรศัพท์ สื่อสังคมออนไลน์ ข้อความสั้น ข้อความโต้ตอบแบบทันที ไปรษณีย์ และวิธีอื่นใดที่ข้าพเจ้าอาจให้ความยินยอมเป็นครั้งคราว </div>
                            <div>
                                <input type="checkbox" checked="checked" id="ConfirmCheckbox" v-model="modalConfirm.isChecked">
                                <span class="checkmark"></span>
                            </div>

                        </label>
                    </div>
                    <button class="btn btn-primary btn-custom-dark" @click="modalConfirm.isChecked? clickOkModalConfirm() : clickCancelModalConfirm()" >{{modalConfirm.strBtnOk}}</button>
                </div>
            </div> -->
            </div>
            <!-- <div class=" topbar bottombar"></div> -->
        </b-modal>

        <!-- alert modal -->
        <b-modal
            id="aaa"
            @hidden="onModalAlertHidden()"
            modal-class="modal-alert alert-term-modal"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-alert-wrapper">
                <div class="modal-base-wrapper">
                    <div class="modal-base alert-body">
                        <div class="modal-base-head"></div>
                        <div class="modal-base-body">
                            <div class="text-error">
                                <p>
                                    กรุณากดยืนยันคำชี้แจ้งการเก็บรักษาข้อมูลส่วนบุคคล
                                </p>
                                <button
                                    class="btn btn-primary btn-custom-dark"
                                    @click="
                                        clickOkModalAlert();
                                        showModalConfirm();
                                    "
                                >
                                    ตกลง
                                </button>
                            </div>
                        </div>
                        <div class="modal-base-footer"></div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import TopBar from "@/components/TopBar.vue";
/**
 * @property {string} view require - view unique name
 * @property {Vue} busModal optional - object for control modal
 *
 * Event callback
 * - alert
 * @event modalAlertOk
 * @event modalAlertHidden
 * - confirm
 * @event modalConfirmOk
 * @event modalConfirmCancel
 * @event modalConfirmHidden
 *
 * Call function by busModal event
 * - confirm
 * @function showConfirmModal
 * @function hideConfirmModal
 */
export default {
    name: "TermAndConditionModal",
    props: {
        view: String,
        busModal: Object
    },
    components: {
        TopBar
    },
    data: function() {
        return {
            modalAlert: {
                id: "modal-term-alert-",
                title: "ss",
                strBtnOk: "",
                message: "",
                tag: ""
            },
            modalConfirm: {
                id: "modal-term-confirm-",
                title: "",
                strBtnOk: "",
                strBtnCancel: "",
                message: "",
                tag: "",
                isChecked: false,
                triggerConsentModal: true
            }
        };
    },
    created: function() {
        this.modalAlert.id += this.view;
        this.modalConfirm.id += this.view;
    },
    mounted: function() {
        this.busModal.$on("showAlertModal", this.showModalAlert);
        this.busModal.$on("hideAlertModal", this.hideModalAlert);

        this.busModal.$on("showConfirmModal", this.showModalConfirm);
        this.busModal.$on("hideConfirmModal", this.hideModalConfirm);
        window.scrollTo(0, 0);
    },
    methods: {
        // === modal alert ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,     // Title text modal
         *      message: '',    // Message text modal
         *      strBtnOk: '',   // Button ok text modal (optional)
         *      tag: '',        // String modal tag name (optional)
         * }
         */
        showModalAlert: function() {
            this.modalAlert.title = "";
            this.modalAlert.message = "";
            this.modalAlert.strBtnOk = "Ok";
            this.modalAlert.tag = "";
            this.$bvModal.show(this.modalAlert.id);
        },
        hideModalAlert: function() {
            this.$bvModal.hide(this.modalAlert.id);
        },
        clickOkModalAlert: function() {
            this.hideModalAlert();
            this.$emit("modalAlertOk", { tag: this.modalAlert.tag });
        },
        onModalAlertHidden: function() {
            this.$emit("modalAlertHidden", { tag: this.modalAlert.tag });
        },

        // === modal confirm ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,         // Title text modal
         *      message: '',        // Message text modal
         *      strBtnOk: '',       // Button ok text modal (optional)
         *      strBtnCancel: '',   // Button cancel text modal (optional)
         *      tag: '',            // String modal tag name (optional)
         * }
         */
        showModalConfirm: function() {
            this.modalConfirm.title = "";
            this.modalConfirm.message = "";
            this.modalConfirm.strBtnOk = "ถัดไป";
            this.modalConfirm.strBtnCancel = "Cancel";
            this.modalConfirm.tag = "";

            this.$bvModal.show(this.modalConfirm.id);
        },
        hideModalConfirm: function() {
            this.$bvModal.hide(this.modalConfirm.id);
        },
        clickOkModalConfirm: function() {
            this.hideModalConfirm();
            this.$emit("modalConfirmOk", { tag: this.modalConfirm.tag });
        },
        clickCancelModalConfirm: function() {
            this.hideThenShowAlert();
            this.$emit("modalConfirmCancel", { tag: this.modalConfirm.tag });
        },
        hideThenShowAlert: function() {
            this.hideModalConfirm();
            this.showModalAlert();
        },
        clickCheckRadio: function() {
            this.modalConfirm.isChecked = !this.modalConfirm.isChecked;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/base/component/modal/modal.scss";
@import "@/style/component/modal/termandcondition.scss";
</style>
<style>
.custom-term-modal > .modal-dialog {
    margin-top: 0px;
    height: 95vh;
}
#modal-term-alert-register > .modal-dialog > .modal-content {
    max-width: 500px;
    background-color: transparent;
}
.consent-modal > .modal-dialog > .modal-content > .modal-body {
    padding: 0px;
}
#modal-term-confirm-register + .modal-backdrop {
    opacity: 1;
}
</style>
